<div class="modal-header">
  <h3 class="modal-title">{{ 'Forgot password' | translate }}</h3>
  <button type="button" class="close" (click)="closeClick()">
    <span aria-hidden="true">×</span>
  </button>
</div>
<div class="modal-body">
  <p>{{ 'Enter your e-mail address with which you have registered with us.' | translate }}</p>
  <p></p>
  <div ngForm class="group_input">
    <input type="email" cdkfocusinitial [(ngModel)]="data.email" email required [readonly]="data.readonly">
    <span class="bar"></span>
    <label>{{ 'E-Mail Address' | translate }}</label>
  </div>
  <p></p>
</div>
<div class="modal-footer">
  <button class="btn btn-primary btn-dialog" [mat-dialog-close]="data.email" [disabled]="!isFormValid">{{ 'Reset password' | translate }}</button>
</div>
